import { State as RootState } from "../index";
import { Module } from "vuex";
import { httpAuthorized } from "@/main";
import { Manager } from "@/types/Manager";

export interface AuthState {
  token: string | null;
  managerInfo: Manager | null;
}

const auth: Module<AuthState, RootState> = {
  namespaced: true,
  state: {
    token: localStorage.getItem("token"),
    managerInfo: null,
  },
  mutations: {
    setToken(state, token: string) {
      state.token = token;
      localStorage.setItem("token", token);
    },
    setManagerInfo(state, managerInfo: Manager) {
      state.managerInfo = managerInfo;
    },
    clearToken(state) {
      state.token = null;
      state.managerInfo = null;
      localStorage.removeItem("token");
    },
  },
  actions: {
    async verifyToken() {
      try {
        const response = await httpAuthorized.get("/verify_token");
        if (response.status === 200) {
          this.commit("auth/setManagerInfo", response.data.data.manager);
          return true;
        }
      } catch (error) {
        console.log("未登录");
        this.commit("auth/clearToken");
        return false;
      }
    },
  },
  getters: {
    managerInfo: (state) => state.managerInfo,
  },
};

export default auth;
